export default class Software {

  constructor(software = {}) {
    this.id = software.id || null
    this.name = software.name || null
  }

  static mutations() {
    return {
      setSoftware: (state, software) => state.software = new Software(software),
      setManager: (state, payload) => {
        state.manager = payload
      }
    }
  }
}